module.exports = __webpack_public_path__ + "img/aboutimg2.77a27864.jpg";